/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-13 00:57:16
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-06-21 16:38:37
 * @Description: file content
 */
import Canvastoimg from "wtc-canvastoimg";
import QRCode from 'qrcode'

var app1 = new Vue({
	el: '#app1',
	data: {
		appAllInfo: null,
		isShowEncourageBtn: false,
		isShowEncourageBox: false,
		showCardEdit: false,
		editInfo: null,
		footerCardInfo: null,
		isShowShare: false,
		showLoading: false,
		isShowPoster: false,
		posterImgUrl: '',
		qrCodeUrl: '',
		isShowShareGuide3: false
	},
	computed: {
		cardInfo() {
			let cardInfo = this.appAllInfo?.fansInfo || '';
			if (cardInfo) {
				if (!cardInfo?.ui_cardtype) { // 默认类型
					cardInfo.ui_cardtype = 1
				}
				if (!cardInfo?.ui_cardcolor) { // 默认颜色
					cardInfo.ui_cardcolor = '#D6BF8E'
				}
			}
			return cardInfo
		},
		isDarker() {
			if (this.cardInfo?.ui_cardcolor == "#D6BF8E" || this.cardInfo?.ui_cardcolor == "#D7D7D8") {
				return true;
			} else {
				return false;
			}
		}
	},
	mounted() {
		let showTips = wj.qs('showShare')
		let _t = this
		console.log('showTips', showTips)
		if (showTips == 1) {
			this.handleShare()
		}
	},
	methods: {
		getAllPostResult(callback) {
			let that = this;
			var count = 0;
			var allPostResult = {};
			comreq.fansInfo(function (data) {
				if (data) {
					allPostResult.fansInfo = that.filterFansInfo(data.obj);
				} else {
					allPostResult.fansInfo = null;
				}
				count++;
			}, myTemp.rscuid || myTemp.openid)

			comreq.getSalerQrcode(function (data) {
				if (data.obj) {
					if (data.obj.total >= 1 && data.obj.list[0].qrcodeurl) {
						allPostResult.qrcode = data.obj.list[0].qrcodeurl
					}
				} else {
					allPostResult.qrcode = "";
				}
				count++;
			}, myTemp.rscuid || myTemp.openid)

			comreq.getUserIntegralInfo(function (data) {
				allPostResult.userIntegralInfo = data;
				count++;
			})

			var tmpInterval = setInterval(function () {
				if (count == 3) {
					callback(allPostResult);
					clearInterval(tmpInterval);
				}
			})
		},
		filterFansInfo(fansInfo) {
			if (fansInfo && wj.isObject(fansInfo)) {
				fansInfo.ui = {
					name: fansInfo.ui_name || fansInfo.name || fansInfo.nickname,
					mobile: fansInfo.ui_mobile || fansInfo.mobile,
					headimg: fansInfo.ui_headimg ? fansInfo.ui_headimg : fansInfo.headimgurl,
					company: (fansInfo.ui_company && fansInfo.ui_company != 'null') ? fansInfo.ui_company : "",
					wechat: fansInfo.ui_weixin
				}
				return fansInfo;
			} else {
				return null;
			}
		},
		// change-is-me
		changeCardIsMe(callback) {
			console.log("更换名片");
			var that = this;
			comreq.fansInfo(function (data) {
				if (data.obj) {
					var fansInfo = that.filterFansInfo(data.obj);
					myTemp.saleCardUser.info = fansInfo;
					callback(fansInfo);
					that.$refs.usercard4.cardInfo = fansInfo;
					comreq.getSalerQrcode(function (data) {
						if (data.obj) {
							if (data.obj.total >= 1 && data.obj.list[0].qrcodeurl) {
								var qrcode = data.obj.list[0].qrcodeurl;
								that.$refs.usercard4.qrcode = qrcode;
							}
						}
					}, myTemp.openid)
				}
			}, myTemp.openid);
			that.setShareIsMe();
		},
		setShareIsMe() {
			console.log("设置传播的rscuid")
			let that = this;
			initWXJSSDK(function () {
				let shareLink = `${location.protocol}//${location.host}/h5/t1.html?id=${myPageData.PageId}`;
				if (myTemp.psn) {
					shareLink = wj.addUrlParamFromObj(shareLink, {
						psn: myTemp.psn
					})
				}
				shareLink = wj.addUrlParamFromObj(shareLink, {
					refereeopenid: myTemp.openid
				})

				if (that.appAllInfo.userIntegralInfo.isAgentType4) {
					shareLink = wj.addUrlParamFromObj(shareLink, {
						agentcuid: myTemp.openid
					})
				} else if (myTemp.saleCardUser.openid) {
					shareLink = wj.addUrlParamFromObj(shareLink, {
						rscuid: myTemp.saleCardUser.openid
					})
				}
				if (myTemp.isWxworkGroupMsg) {
					shareLink += "&corpId=" + myTemp.corpId;
					shareLink += "&qwUserId=" + myTemp.qwUserId;
					shareLink += "&batchId=" + myTemp.batchId;
				}
				shareLink = wj.addUrlParamFromObj(shareLink, {
					tt: new Date().getTime()
				})
				if (myTemp.share_api) {
					shareLink = myTemp.share_api.replace("{desturl}", encodeURIComponent(shareLink));
				}
				return shareLink;
			})
		},
		clickShowEncourageBox() {
			if (myTemp.isBtnEncourageGoInvitePage) {
				location.href = `${location.protocol}//${location.host}/marketies/${wj.browser.versions.wxwork ? 'qwdesk' : 'desk'}/pages/encourage/invite`;
			} else {
				this.isShowEncourageBox = true
				document.getElementsByTagName("body")[0].style.overflow = "hidden";
				document.getElementsByTagName("body")[0].style.maxHeight = "100vh";
			}
		},
		closeEncourageBox() {
			this.isShowEncourageBox = false;
			document.getElementsByTagName("body")[0].style.overflow = "";
			document.getElementsByTagName("body")[0].style.maxHeight = "";
		},
		handleCardEdit(isShow, editInfo, reload) {
			if (isShow) {
				// 隐藏切换页面
				this.editInfo = editInfo
				console.log('editInfo', editInfo)
				$('#app1').siblings().addClass("display-none")
				$('#edit').siblings().addClass("display-none")
				this.showCardEdit = true
			} else {
				this.showCardEdit = false
				this.editInfo = null
				if (reload) { // 刷新名片设置
					this.$refs?.usercardlight?.initCardConfig()
				}
				$('#app1').siblings().removeClass("display-none")
				$('#edit').siblings().removeClass("display-none")
			}
		},
		handleCardNav(navType) {
			this.$refs.usercardlight[navType]()
		},
		setFooterCard(cardInfo) {
			console.log('setFooterCard', cardInfo)
			this.footerCardInfo = cardInfo
		},
		// 关闭网页分享引导
		closeShare() {
			this.isShowShare = false;
			document.getElementsByTagName("body")[0].style.overflow = "";
			document.getElementsByTagName("body")[0].style.maxHeight = "";
		},
		handleShare() {
			this.shareText = myPageData?.sharetext?.replace(/\n/g, '<br/>') || '';
			this.isShowShare = true;
			document.getElementsByTagName("body")[0].style.overflow = "hidden";
			document.getElementsByTagName("body")[0].style.maxHeight = "100vh";
		},
		makeQrcode() {
			console.log('make')
			this.closeShare() // 关闭分享
			this.showLoading = true
			let opts = {
				errorCorrectionLevel: 'H',
				type: 'image/jpeg',
				quality: 0.3,
				margin: 1,
				color: {
					dark: "#38352F",
					light: "#FFFFFF"
				}
			}
			let link = window.shareLink
			QRCode.toDataURL(link, opts).then(url => {
				this.qrCodeUrl = url
				this.createPoster(this.qrCodeUrl)
			})
		},
		closeShowImg() {
			this.isShowPoster = false;
			document.getElementsByTagName("body")[0].style.overflow = "";
			document.getElementsByTagName("body")[0].style.maxHeight = "";
		},
		changeImg(isInit) {
			comreq.getBgPoster().then(res => {
				console.log('getPosterImg', res)
				if (res.code == 0 && res.data) {
					this.posterBgUrl = res.data
					if (isInit) {
						return
					}
					if (this.qrCodeUrl) {
						this.createPoster(this.qrCodeUrl)
					} else {
						this.makeQrcode()
					}
				}
			})
		},
		createPoster(qrcode) {
			console.log('createPoster')
			let bgWidth = 750;
			let bgHeight = 1311.5;
			let bgColor = this.cardInfo?.ui_cardcolor
			let textColor = this.isDarker ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 0.7)'
			let nameColor = this.isDarker ? '#000000' : '#ffffff'
			let introText = ''
			let introTextLeft = 150
			let nameLen = wj.getStrBlen(this.cardInfo?.ui?.name)
			if (this.cardInfo?.ui?.company) {
				introText = this.cardInfo?.ui?.company
			}
			if (nameLen > 4) {
				introTextLeft = nameLen * (32.8 / 2) + 84
			}
			let cvsImgData = [
				{
					type: "img",
					zIndex: 2,
					x: 0,
					y: 0,
					width: 750,
					height: 1124,
					content: this.posterBgUrl,
				},
				{
					type: "img",
					zIndex: 2,
					x: 0,
					y: 0,
					width: bgWidth,
					height: 300,
					content: "https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/poster_bg.png",
				},
				{
					type: "img",
					zIndex: 2,
					x: 0,
					y: 1124,
					width: bgWidth,
					height: 187.5,
					content: "https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/bg.png",
				},
				{
					type: "img",
					zIndex: 2,
					x: 56,
					y: 1070,
					shape: 'arc',
					width: 112,
					height: 112,
					content: this.cardInfo.ui.headimg,
				},
				{
					type: "text",
					zIndex: 2,
					x: 56,
					y: 1192,
					content: this.cardInfo.ui.name,
					fontSize: `${32.8}px 微软雅黑`,
					color: nameColor,
					fontWeight: 500,
				},
				{
					type: "text",
					zIndex: 2,
					x: introTextLeft,
					y: 1196.7,
					content: introText,
					fontSize: `${28}px 微软雅黑`,
					color: textColor,
				},
				{
					type: "img",
					zIndex: 2,
					x: 56,
					y: 1251,
					shape: '',
					width: 32.8,
					height: 32.8,
					content: this.isDarker ? 'https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/darker-phone.png' : 'https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/light-phone.png',
				},
				{
					type: "text",
					zIndex: 2,
					x: 98.4,
					y: 1248,
					content: this.cardInfo.ui.mobile,
					fontSize: `${28}px 微软雅黑`,
					color: textColor,
				},
				{
					type: "img",
					zIndex: 2,
					x: 571,
					y: 1147,
					shape: '',
					width: 140,
					height: 140,
					content: qrcode,
				}
			];
			if (this.cardInfo.ui_weixin) {
				cvsImgData = cvsImgData.concat(
					[
						{
							type: "img",
							zIndex: 2,
							x: 307,
							y: 1250,
							shape: '',
							width: 32.8,
							height: 32.8,
							content: this.isDarker ? 'https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/darker-wx.png' : 'https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/light-wx.png',
						},
						{
							type: "text",
							zIndex: 2,
							x: 349,
							y: 1248,
							content: this.cardInfo.ui_weixin,
							fontSize: `${28}px 微软雅黑`,
							color: textColor,
						}
					]
				)
			}
			let title = myPageData.BrowserTabTitle
			let textWidth = 592;
			let len = title.length
			let lastEnd = 0
			let lineNum = 0
			if (len) { // 文字换行
				for (let index = 1; index <= len; index++) {
					let str = title.substring(lastEnd, index)
					let curLineWidth = wj.getStrBlen(str) * (49 / 2)
					if (curLineWidth == textWidth) {
						cvsImgData.push({
							type: "text",
							zIndex: 2,
							x: 79,
							y: 56 + 75 * lineNum,
							content: title.substring(lastEnd, index),
							fontSize: `${49}px 微软雅黑`,
							color: '#ffffff',
							fontWeight: 600,
						})
						lastEnd = index
						lineNum = lineNum + 1
					} else if (curLineWidth > textWidth) {
						cvsImgData.push({
							type: "text",
							zIndex: 2,
							x: 79,
							y: 56 + 75 * lineNum,
							content: title.substring(lastEnd, index - 1),
							fontSize: `${49}px 微软雅黑`,
							color: '#ffffff',
							fontWeight: 600,
						})
						lastEnd = index - 1
						lineNum = lineNum + 1
					} else if (index == len) {
						cvsImgData.push({
							type: "text",
							zIndex: 2,
							x: 79,
							y: 56 + 75 * lineNum,
							content: title.substring(lastEnd, index),
							fontSize: `${49}px 微软雅黑`,
							color: '#ffffff',
							fontWeight: 600,
						})
					}
				}
			}
			const cvsimg = new Canvastoimg({
				width: bgWidth, //画布宽度
				height: bgHeight, //画布高度
				color: bgColor,  //画布背景色
				data: cvsImgData
			})
			cvsimg.down().then((canvas) => {
				/* 获取到的是canvas对象 */
				this.sharePoster = canvas.toDataURL("image/jpg");
				this.posterImgUrl = this.sharePoster;
				this.showLoading = false;
				this.isShowPoster = true;
				document.getElementsByTagName("body")[0].style.overflow = "hidden";
				document.getElementsByTagName("body")[0].style.maxHeight = "100vh";
			});
		},
		init() {
			/**
			 * 1、main 如果链接有rscuid 或 自己的信息（因为如果自己是销售也会用到），请求获取rscuid的粉丝信息、请求获取qrcode用于卡片展示。
			 * 2、main 获取用户整体的信息，用于销售判断。 
			 * 3、main 是销售，初始化分享rscuid是自己的openid
			 * 
			 * 名片：有rscuid 或 是销售 》展示 名片信息
			 * 名片：有rscuid 且 是销售 且 rscuid不等于自己的openid =》名片信息 展示 换成我的
			 * 名片：有rscuid 且 是销售 且 rscuid等于自己的openid =》名片信息 展示 编辑
			 * 名片：点击换成我的、更改cardInfo信息为自己的信息，初始化分享rscuid是自己的openid
			 * 
			 */
			var that = this;
			// this.getAllPostResult(function (data) {
			//   that.appAllInfo = data;
			//   // 我是销售 或 置业经纪人 (data.userIntegralInfo.isAgent && data.userIntegralInfo.agentInfo.authtype == 2) 且连接上没有rscuid
			//   if (that.appAllInfo.userIntegralInfo && that.appAllInfo.userIntegralInfo.isSale && !myTemp.rscuid) {
			//     that.setShareIsMe();
			//   }
			// })

			/**
			 * 20201225 新改变
				1、销售看到的名片始终是自己的
				2、去掉换成我的，销售转发出去直接就是自己的名片
				3、传播致电和传播咨询和名片一致
			
				具体做：
				1、没有rscuid原始链接进来
				1.1 自己是销售 展示自己名片
				1.2 自己非销售 不展示名片
			
				2、有rscuid的链接进来
				2.1 自己是销售 展示自己名片
				2.2 自己非销售 展示rscuid的名片
			
				3、有名片的情况下，致电按钮、咨询按钮和名片人保持一致
				4、换一换去掉，销售转发直接变换成销售的
			
			
			 */

			let tmpAppAllInfo = {
				userIntegralInfo: null,
				fansInfo: null,
				qrcode: ''
			};
			myTemp.saleCardUser = {
				openid: '',
				info: {},
				postOver: false,
			}
			let qsData = wj.getParamFromUrl(location.href);
			comreq.getUserIntegralInfo((userIntegralInfo) => {
				tmpAppAllInfo.userIntegralInfo = userIntegralInfo;
				myTemp.userIntegralInfo = userIntegralInfo;
				myTemp.isOpenEncourage = window.myPageData.Other.cfg_markting;
				if (myTemp.isOpenEncourage && !myTemp.issubscribe) {
					if (userIntegralInfo?.userInfo?.user?.appid) {
						myTemp.appid = userIntegralInfo?.userInfo?.user?.appid;
						comreq.getTemporaryQRCode({
							appid: myTemp.appid,
							openid: myTemp.openid,
							pageid: myPageData.PageId
						}).then(res => {
							if (res.data) {
								$(".wx-qrcode .qr").attr("src", res.data)
							}
						})
					}
				}

				if (!userIntegralInfo.isSale && !userIntegralInfo.isAgentType4) {
					// 判断是否展示无门槛用户激励按钮
					if (window.myPageData.Other.cfg_markting) {
						this.isShowEncourageBtn = true;
					}
				}
				if (!qsData.rscuid && !qsData.agentcuid) {
					if (userIntegralInfo.isSale || userIntegralInfo.isAgentType4) {
						myTemp.saleCardUser.openid = myTemp.openid;
					} else {
						myTemp.saleCardUser.openid = '';
					}
				} else {
					if (userIntegralInfo.isSale || userIntegralInfo.isAgentType4) {
						myTemp.saleCardUser.openid = myTemp.openid;
					} else {
						myTemp.saleCardUser.openid = myTemp.rscuid || myTemp.agentcuid;
					}
				}
				new Promise((resolve, reject) => {
					let toId = "";
					if (myTemp.saleCardUser.openid) {
						toId = myTemp.saleCardUser.openid
						resolve(toId)
					} else {
						window.comreq.getReceptionByProject().then(defaultSaleOpenid => {
							if (defaultSaleOpenid) {
								toId = defaultSaleOpenid;
							}
							resolve(toId)
						})
					}
				}).then(toId => {

					if (toId) {
						myTemp.consultingLink = `${location.protocol}//${location.host}/marketies/${wj.browser.versions.wxwork ? 'qwdesk' : 'desk'}/pages/fans/sale-fans-interaction`;
						myTemp.consultingLink = wj.addUrlParamFromObj(myTemp.consultingLink, {
							referenceopenid: myTemp.refereeopenid || '',
							receiveropenid: toId,
							projectid: myPageData.Pid || '',
							pageid: myPageData.PageId
						})
					} else {
						myTemp.consultingLink = `${location.protocol}//${location.host}/marketies/rc/cus-service.html`;
						myTemp.consultingLink = wj.addUrlParamFromObj(myTemp.consultingLink, {
							mobile: myPageData.Tel || '',
							referenceopenid: myTemp.refereeopenid || '',
							pageid: myPageData.PageId
						})
					}
					if (myTemp.qwkfInfo?.corpid && myTemp.qwkfInfo?.openKfid) {
						wj.handlerQwkf(toId);
					}
				})
				myTemp.saleCardUser.postOver = true;

				// 判断 是否有 myTemp.saleCardUser.openid
				if (myTemp.saleCardUser.openid) {

					// 判断 myTemp.saleCardUser.openid 还是否是销售或者职业经纪人、中介
					new Promise((resolve, reject) => {
						let isSaleCardUserValid = false;
						comreq.getUserInfo(function (data) {
							// 还是销售
							let userInfo = data.obj;
							if (userInfo && userInfo.user && userInfo.role && userInfo.role.length) {
								isSaleCardUserValid = true;
								resolve(isSaleCardUserValid)
								return;
							} else {
								comreq.getAgentInfoByOpenid({
									openid: myTemp.saleCardUser.openid
								}).then(resAgentInfo => {
									if (resAgentInfo && resAgentInfo.data && resAgentInfo.data.authtype == 4) {
										isSaleCardUserValid = true;
										resolve(isSaleCardUserValid)
									} else {
										resolve(isSaleCardUserValid)
									}
								})
							}
						}, myTemp.saleCardUser.openid)

					}).then((isSaleCardUserValid) => {
						if (isSaleCardUserValid) {
							var postCount = 0;
							comreq.fansInfo(function (data) {
								tmpAppAllInfo.fansInfo = that.filterFansInfo(data.obj);
								myTemp.saleCardUser.info = tmpAppAllInfo.fansInfo;
								postCount++;
							}, myTemp.saleCardUser.openid)
							comreq.getSalerQrcode(function (data) {
								if (data.obj && data.obj.list && data.obj.list.length > 0) {
									if (data.obj.total >= 1 && data.obj.list[0].qrcodeurl) {
										tmpAppAllInfo.qrcode = data.obj.list[0].qrcodeurl
									}
								}
								postCount++;
							}, myTemp.saleCardUser.openid)
							var tmpInterval = setInterval(function () {
								if (postCount == 2) {
									that.appAllInfo = tmpAppAllInfo;
									console.log('appAllInfo', JSON.parse(JSON.stringify(tmpAppAllInfo)))
									that.setShareIsMe();
									clearInterval(tmpInterval);
								}
							})
						} else {
							that.appAllInfo = tmpAppAllInfo;
							console.log('appAllInfo', JSON.parse(JSON.stringify(tmpAppAllInfo)))
						}
					})
				} else {
					that.appAllInfo = tmpAppAllInfo;
					console.log('appAllInfo', JSON.parse(JSON.stringify(tmpAppAllInfo)))
				}
			})
		}
	},
	async created() {
		this.init()
		this.changeImg(true)
		if (myTemp.openid) {
			yqAnalytics.setUserInfo({
				openId: myTemp.openid
			})
		}
		let propertyValueBaseData = await biz.handlerGetYqAnalyticsPropertyValueBaseData();
		yqAnalytics.pageOpen({
			pageUrl: propertyValueBaseData.pageUrl,
			propertyValue: JSON.stringify(propertyValueBaseData)
		})
	}
});
window.myVue = app1;